export default {
    routerName: '外国為替管理',
    exchange: {
        searchName: '検索条件',
        jpy: '100日本円',
        usd: '1米ドル',
        hkd: '1香港ドル',
        eur: '1ユーロ',
        gpb: '1ポンド',
        year: '年',
        month: '月',
        day: '日',
        createTime: '作成日付',
        createStartTime: '開始日付',
        createEndTime: '終了日付',
    },
    table: {
        id: 'ID',
        jpy: '100日本円',
        usd: '1米ドル',
        hkd: '1香港ドル',
        eur: '1ユーロ',
        gpb: '1ポンド',
        year: '年',
        month: '月',
        day: '日',
        createTime: '作成日付',
    },
};
